module.exports = require('./lib');


//////////////////
// WEBPACK FOOTER
// ./~/react-autosize-textarea/index.js
// module id = 981
// module chunks = 0